@if (shipment) {
  <div class="container single-view" id="edit-shipment">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/shipments/' + shipmentId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SHIPMENTS.BTN_BACK_TO_SHIPMENT' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-shipment-title" class="section-title">{{ 'SHIPMENT_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="shipmentForm" data-testid="edit-shipment-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="edit-shipment-details" class="border-b pb-3">{{ 'SHIPMENT_UPDATE.SHIPMENT_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-shipment-field-reference" class="block text-sm" for="reference">{{ 'SHIPMENT_UPDATE.SHIPMENT_REFERENCE' | translate }} <i
                    class="icon-required-field"></i></label>
                    <input data-testid="edit-shipment-reference-input" type="text" formControlName="reference" autocomplete="off">
                    @if (shipmentForm.get('reference')?.invalid && shipmentForm.get('reference')?.touched) {
                      <small data-testid="reference-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-shipment-field-retailer" class="block text-sm" for="retailer">{{ 'SHIPMENT_UPDATE.RETAILER' | translate }} <i
                    class="icon-required-field"></i></label>
                    <app-custom-dropdown
                      data-testid="retailer"
                      [placeholder]="'SALE_UPDATE.SELECT_RETAILER' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="storeData.retailer.rowsPerPage"
                      [totalCount]="storeData.retailer.totalRecords"
                      [totalPages]="getTotalPages(storeData.retailer.totalRecords, storeData.retailer.rowsPerPage)"
                      [options]="storeData.retailer.list"
                      formControlName="retailer"
                      (onLazyLoad)="onLazyLoadStores($event)">
                    </app-custom-dropdown>
                    @if (shipmentForm.get('retailer')?.invalid && shipmentForm.get('retailer')?.touched) {
                      <small data-testid="retailer-mandatory"  class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-shipment-field-origin" class="block text-sm" for="origin">{{ 'SHIPMENT_UPDATE.SHIPMENT_ORIGIN' | translate }} <i
                    class="icon-required-field"></i></label>
                    <app-custom-dropdown
                      data-testid="origin"
                      [placeholder]="'SALE_UPDATE.SELECT_RETAILER' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="storeData.origin.rowsPerPage"
                      [totalCount]="storeData.origin.totalRecords"
                      [totalPages]="getTotalPages(storeData.origin.totalRecords, storeData.origin.rowsPerPage)"
                      [options]="storeData.origin.list"
                      formControlName="origin"
                      (onLazyLoad)="onLazyLoadOriginStores($event)">
                    </app-custom-dropdown>
                    @if (shipmentForm.get('origin')?.invalid && shipmentForm.get('origin')?.touched) {
                      <small data-testid="origin-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-shipment-field-destination" class="block text-sm" for="destination">{{ 'SHIPMENT_UPDATE.SHIPMENT_DESTINATION' | translate }} <i
                    class="icon-required-field"></i></label>
                    <app-custom-dropdown
                      data-testid="destination"
                      [placeholder]="'SALE_UPDATE.SELECT_RETAILER' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="storeData.destination.rowsPerPage"
                      [totalCount]="storeData.destination.totalRecords"
                      [totalPages]="getTotalPages(storeData.destination.totalRecords, storeData.destination.rowsPerPage)"
                      [options]="storeData.destination.list"
                      formControlName="destination"
                      (onLazyLoad)="onLazyLoadDestinationStores($event)">
                    </app-custom-dropdown>
                    @if (shipmentForm.get('destination')?.invalid && shipmentForm.get('destination')?.touched) {
                      <small data-testid="destination-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12">
                    <label data-testid="edit-shipment-field-comments" class="block text-sm" for="comments">{{ 'SHIPMENT_UPDATE.COMMENTS' | translate }}</label>
                    <textarea data-testid="edit-shipment-comments-input" type="text" formControlName="comment" autocomplete="off"></textarea>
                    @if (shipmentForm.get('comment')?.invalid && shipmentForm.get('comment')?.touched) {
                      <small data-testid="comments-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-shipment-update-shipment-button" class="btn primary-btn" [disabled]="shipmentForm.invalid"
                      (click)="submitForm()">{{ 'SHIPMENT_UPDATE.BTN_UPDATE_SHIPMENT' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
